import React from 'react';
import BreadCrumb from 'jbc-front/components/BreadCrumb';
import { REPORT_INDEX } from 'src/constants/EndpointUrls';
import ShowAllowanceDeductionFormConnectionContainer from '../containers/ShowAllowanceDeductionFormConnectionContainer';
import { withTranslation } from 'react-i18next';

class ShowAllowanceDeductions extends React.Component {
  componentDidMount() {
    const { allGroupsAndSubgroups, csvAllowanceDeductionFormats, uniquePayrollRuleGroups } = this.props;
    allGroupsAndSubgroups();
    csvAllowanceDeductionFormats();
    uniquePayrollRuleGroups();
  }

  render() {
    const { match, t } = this.props;

    return (
      <div className="l-wrap-xl l-contents-wrap">
        {/* <BreadCrumb>
          <BreadCrumb.Item label="書類作成" path={REPORT_INDEX} />
          <BreadCrumb.Item label="支給・控除等一覧表" />
        </BreadCrumb> */}
        <div className="l-title-wrap">
          <h1 className="m-title-main">{t('features.EmployeeBonus.components.AllowanceDeductionMethod.Provision_and_deduction_list')}</h1>
          <p className="m-title-main-note">
            {t('features.EmployeePays.components.ShowAllowanceDeductions.Check_values_such_as_attendance_items_provision_and_deduction_items_or_employer_contribution_in_each_month_at_the_same_time')}<br />
            {t('features.EmployeePays.components.ShowAllowanceDeductions.Please_set_format_for_items_and_employee_group_you_would_like_to_export_beforehand')}<br />
            {t('features.EmployeePays.components.ShowAllowanceDeductions.Employees_group_can_be_exported_from_group_when_confirming_salary')}
          </p>
        </div>
        <ShowAllowanceDeductionFormConnectionContainer csvType={'pay'} back={match.path} />
      </div>
    );
  }
}

export default withTranslation()(ShowAllowanceDeductions);
